import { useEffect, useRef } from 'react';
import { useScope } from '@workspace/scope-context';

import { useSession } from '@/context/SessionContext';

export function ScopeSessionSync() {
  const { mode, activeTenant, loading: scopeLoading } = useScope();
  const { session, loading: sessionLoading, refresh } = useSession();
  const attemptedKeyRef = useRef<string | null>(null);

  const desiredTenantId = mode === 'tenant' ? activeTenant?.id ?? null : null;
  const currentTenantId = session?.tenantId ?? null;
  const desiredKey = `${mode}:${desiredTenantId ?? ''}`;

  useEffect(() => {
    if (scopeLoading || sessionLoading || !session) {
      return;
    }

    if (desiredTenantId === currentTenantId) {
      attemptedKeyRef.current = null;
      return;
    }

    if (attemptedKeyRef.current === desiredKey) {
      return;
    }

    attemptedKeyRef.current = desiredKey;
    void refresh();
  }, [currentTenantId, desiredKey, desiredTenantId, refresh, scopeLoading, session, sessionLoading]);

  return null;
}
